export const SIM_PROVIDER_ACCOUNT_CREATE_EDIT_OPEN_MODAL = "SIM_PROVIDER_ACCOUNT_CREATE_EDIT_OPEN_MODAL";
export const SIM_PROVIDER_ACCOUNT_CREATE_REQUEST = "SIM_PROVIDER_ACCOUNT_CREATE_REQUEST";
export const SIM_PROVIDER_ACCOUNT_CREATE_RESULT = "SIM_PROVIDER_ACCOUNT_CREATE_RESULT";
export const SIM_PROVIDER_ACCOUNT_EDIT_REQUEST = "SIM_PROVIDER_ACCOUNT_EDIT_REQUEST";
export const SIM_PROVIDER_ACCOUNT_EDIT_RESULT = "SIM_PROVIDER_ACCOUNT_EDIT_RESULT";
export const SIM_PROVIDER_ACCOUNT_GET_REQUEST = "SIM_PROVIDER_ACCOUNT_GET_REQUEST";
export const SIM_PROVIDER_ACCOUNT_GET_RESULT = "SIM_PROVIDER_ACCOUNT_GET_RESULT";